import { LoadingImg } from '@/components/loading-img';
import {
  cn,
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@mgrvtechgroup/admin-ds';
import { useState, type ComponentProps } from 'react';

/**
 * 눌러서 화면 가득 확대해 볼 수 있는 사진. 이미지 칸(className)은 부르는 쪽이 정하고, 눌리는 칸(buttonClassName)은
 * 이미지를 감싸는 버튼이다. 확대할 때 더 큰 원본이 따로 있으면 zoomSrc로 넘긴다(없으면 src).
 * 키보드(Tab·Enter·Space)로도 열고, Esc·X로 확대만 닫는다 — 안에 든 다이얼로그는 그대로 남는다.
 */
export function ZoomableImg({
  zoomSrc,
  buttonClassName,
  alt,
  src,
  ...props
}: ComponentProps<typeof LoadingImg> & { zoomSrc?: string; buttonClassName?: string }) {
  const [open, setOpen] = useState(false);
  const label = alt ?? '이미지';
  return (
    <>
      <button
        type="button"
        aria-label={`${label} 확대 보기`}
        aria-haspopup="dialog"
        className={cn(
          'focus-visible:ring-ring block max-w-full cursor-zoom-in focus-visible:ring-2 focus-visible:outline-none',
          buttonClassName,
        )}
        onClick={() => {
          setOpen(true);
        }}
      >
        <LoadingImg {...props} src={src} alt={alt} />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="h-[96vh] w-[96vw] max-w-none sm:max-w-none">
          <DialogHeader className="sr-only">
            <DialogTitle>{label}</DialogTitle>
          </DialogHeader>
          <DialogBody className="flex min-h-0 flex-1 items-center justify-center p-0">
            {open ? (
              <img
                src={zoomSrc ?? src}
                alt={label}
                className="max-h-full max-w-full object-contain"
              />
            ) : null}
          </DialogBody>
        </DialogContent>
      </Dialog>
    </>
  );
}
